import { render, staticRenderFns } from "./FileSign.vue?vue&type=template&id=1f7472b4&scoped=true"
import script from "./FileSign.vue?vue&type=script&lang=ts"
export * from "./FileSign.vue?vue&type=script&lang=ts"
import style0 from "./FileSign.vue?vue&type=style&index=0&id=1f7472b4&prod&lang=scss&scoped=true"
import style1 from "./FileSign.vue?vue&type=style&index=1&id=1f7472b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7472b4",
  null
  
)

export default component.exports